import { Themed } from 'theme-ui'
import ImgixImage from '../../elements/imgix-img'
import { useState } from 'react'
import Modal from '../../elements/modal'

const Person = ({ name, title, image, bio }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const toggleModal = () => setModalOpen(!modalOpen)
  const handleKeypress = ({ key }) => key === 'Enter' && toggleModal()
  return (
    <div
      sx={{
        display: 'flex',
        alignItems: 'center',
        my: 'md',
        cursor: 'pointer',
      }}
      onClick={toggleModal}
      onKeyPress={handleKeypress}
      role='link'
      tabIndex={0}
    >
      <div sx={{ height: 72, width: 72, mr: 'md' }}>
        <ImgixImage
          src={image}
          height='72'
          width='72'
          sx={{ borderRadius: 10000 }}
          imgixParams={{ fit: 'facearea', facepad: 3 }}
        />
      </div>
      <div>
        <Themed.h3 sx={{ color: 'primary' }}>{name}</Themed.h3>
        {title}
      </div>

      <Modal close={toggleModal} isOpen={modalOpen}>
        <div
          sx={{
            display: 'flex',
            flexDirection: ['column', 'row'],
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <div sx={{ width: ['100%', '50%'], flexShrink: 0 }}>
            <ImgixImage
              src={image}
              sx={{ maxWidth: '100%', width: '100%', height: 'auto', display: ['block', 'none'] }}
              height={400}
              width={600}
              imgixParams={{
                fit: 'crop',
                crop: 'faces,entropy',
              }}
              sizes='(min-width: 768px) 400px, calc(100vw - 32px)'
            />
            <ImgixImage
              src={image}
              sx={{ maxWidth: '100%', width: '100%', height: 'auto', display: ['none', 'block'] }}
              height={600}
              width={400}
              imgixParams={{
                fit: 'crop',
                crop: 'faces,entropy',
              }}
              sizes='(min-width: 768px) 400px, calc(100vw - 32px)'
            />
          </div>
          <div sx={{ p: 'md' }}>
            <Themed.h3 sx={{ color: 'primary' }}>{name}</Themed.h3>
            <Themed.p>{title}</Themed.p>
            <p sx={{ mt: ['sm', 'lg'] }} />
            {bio}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Person
